import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-165" data-mp="jurd1jy55xga">
      {visible ? <motion.div initial={{
      y: 90
    }} animate={{
      y: 0
    }} exit={{
      y: 90
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-ink-950/95 px-4 py-3 backdrop-blur" data-id="element-166" data-mp="jtppwh3upki7">
          <div className="mx-auto flex max-w-3xl items-center justify-between gap-4" data-id="element-167" data-mp="297uuhugi9ufx">
            <div className="hidden sm:block" data-id="element-168" data-mp="24bdxsbv8q7r8">
              <p className="text-xs uppercase tracking-[0.18em] text-white/45" data-id="element-169" data-mp="3if8oo6177hy1">
                Oferta de hoy
              </p>
              <p className="font-display text-2xl text-white" data-id="element-170" data-mp="3mhn6cmt4sbnq">
                <span className="mr-2 text-base text-white/35 line-through" data-id="element-171" data-mp="38h2optyyclvt">$1,997</span>$27
              </p>
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#22a447] px-5 py-3 text-sm font-extrabold text-white ring-1 ring-inset ring-white/20 transition-colors hover:bg-[#1e9440] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#22a447]/50 sm:flex-none sm:px-8" data-id="element-172" data-mp="3df49qkfxuv9x">
              <ShoppingCartIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="7awsn4qx911" />
              ¡Quiero el 48 Hrs AI Cash Machine!
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}